import { useState, useEffect } from "react";
import { isDev } from "../../helpers/utilities";

import { VscBug } from "react-icons/vsc";

/*interface TableDebugProps {
  initialIsDebugOpen?: boolean;
  viewDebugMode?: boolean;
  data: T[];
}
*/

function TableDebug({
  className,
  data = [],
  initialIsDebugOpen = false,
  viewDebugMode = false,
}) {
  const [isDebugOpen, setIsDebugOpen] = useState(initialIsDebugOpen);
  const [debugMode, setDebugMode] = useState(false);

  useEffect(() => {
    setIsDebugOpen(initialIsDebugOpen);
  }, [initialIsDebugOpen]);

  useEffect(() => {
    setDebugMode(viewDebugMode);
  }, [viewDebugMode]);

  return isDev() && debugMode ? (
    <div className={className}>
      <button
        onClick={() => setIsDebugOpen((prev) => !prev)}
        type="button"
        className="tw-bg-transparent tw-rounded-full tw-outline-none tw-border-0 focus:tw-outline-none"
      >
        <VscBug className="tw-h-6 tw-w-6" />
      </button>
      {isDebugOpen && <pre>{JSON.stringify(data, null, 2)}</pre>}
    </div>
  ) : null;
}

export default TableDebug;
